import { render, staticRenderFns } from "./WidgetCheckRevisions.vue?vue&type=template&id=6a371c34&scoped=true&"
import script from "./WidgetCheckRevisions.vue?vue&type=script&lang=js&"
export * from "./WidgetCheckRevisions.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCheckRevisions.vue?vue&type=style&index=0&id=6a371c34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a371c34",
  null
  
)

export default component.exports